module.exports = __webpack_public_path__ + "img/after2.0dd03eea.jpg";